import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  resetFormData,
  setAdditionalData,
  setSubmitting,
  setUser,
} from "../store/features/authSlice";
import { toggleCheckInbox } from "../store/features/modalSlice";
import Button from "./shared/Button";
import CustomInput from "./shared/CustomInput";
import { base_URL } from "../config/config";
import PhoneInput from "react-phone-number-input";
import { getCountryCallingCode } from "react-phone-number-input/input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
// import { sendOtpApi, verifyOtpApi } from "../api/mobileVerify-api"; // DISABLED OTP
import { completeGoogleProfile } from "../api/googleProfile.request";

const AdditionalDetails = () => {
  const dispatch = useDispatch();
  const [country, setCountry] = useState("AE");
  const [countryCode, setCountryCode] = useState("+971");
  const { formData, additionalData, isSubmitting } = useSelector(
    (state) => state.auth
  );

  // ---------- OTP state (DISABLED) ----------
  // const [otpSent, setOtpSent] = useState(false);
  // const [otpCode, setOtpCode] = useState("");
  // const [otpVerified, setOtpVerified] = useState(false);
  // const [otpLoading, setOtpLoading] = useState(false);
  // const [resendIn, setResendIn] = useState(0);

  // useEffect(() => {
  //   if (!otpSent || resendIn <= 0) return;
  //   const t = setInterval(() => setResendIn((s) => s - 1), 1000);
  //   return () => clearInterval(t);
  // }, [otpSent, resendIn]);

  const handleCountryChange = (countryCode) => {
    if (countryCode) {
      setCountry(countryCode);
      try {
        const dialCode = getCountryCallingCode(countryCode);
        setCountryCode(`+${dialCode}`);
        if (!additionalData.mobileNumber) {
          // FIX: dispatch the Redux action
          dispatch(
            setAdditionalData({ name: "mobileNumber", value: `+${dialCode}` })
          );
        }
      } catch (error) {
        console.error("Error getting country calling code:", error);
        setCountryCode("+");
      }
    }
  };

  const [error, setError] = React.useState({
    select: "",
    companyName: "",
    mobileNumber: "",
  });

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    dispatch(setAdditionalData({ name: "select", value: selectedValue }));
    if (selectedValue !== "corporate") {
      dispatch(setAdditionalData({ name: "companyName", value: "" }));
    }
  };

  const handleCompanyNameChange = (e) => {
    dispatch(setAdditionalData({ name: "companyName", value: e.target.value }));
  };

  const handleMobileNumberChange = (value) => {
    dispatch(setAdditionalData({ name: "mobileNumber", value }));
    setError((prev) => ({ ...prev, mobileNumber: "" }));
    // reset OTP state when user changes number (DISABLED)
    // setOtpSent(false);
    // setOtpCode("");
    // setOtpVerified(false);
    // setResendIn(0);
  };

  // ---------- Send OTP (DISABLED) ----------
  // const sendOtp = async () => {
  //   const number = additionalData.mobileNumber;
  //   if (!number) {
  //     setError((p) => ({ ...p, mobileNumber: "Mobile number is required." }));
  //     return;
  //   }
  //   const parsed = parsePhoneNumberFromString(number, country || "AE");
  //   if (!parsed || !parsed.isValid()) {
  //     setError((p) => ({
  //       ...p,
  //       mobileNumber: "Invalid mobile number for the selected country.",
  //     }));
  //     return;
  //   }

  //   try {
  //     setOtpLoading(true);
  //     const res = await sendOtpApi(parsed.number); // expects E.164
  //     if (res.status !== "pending") throw new Error("Failed to send OTP");
  //     setOtpSent(true);
  //     setOtpVerified(false);
  //     setResendIn(45);
  //     toast.success("OTP sent");
  //   } catch (err) {
  //     const msg = err.message || "Failed to send OTP";
  //     toast.error(msg);
  //   } finally {
  //     setOtpLoading(false);
  //   }
  // };

  // ---------- Verify OTP (DISABLED) ----------
  // const verifyOtp = async () => {
  //   const number = additionalData.mobileNumber;
  //   if (!otpCode) return toast.error("Enter the OTP");
  //   const parsed = parsePhoneNumberFromString(number, country || "AE");
  //   if (!parsed || !parsed.isValid()) {
  //     return toast.error("Invalid mobile number.");
  //   }

  //   try {
  //     setOtpLoading(true);
  //     const { valid } = await verifyOtpApi({
  //       to: parsed.number,
  //       code: otpCode,
  //     });
  //     if (valid) {
  //       setOtpVerified(true);
  //       toast.success("Phone verified ✅");
  //     } else {
  //       setOtpVerified(false);
  //       toast.error("Incorrect code. Try again.");
  //     }
  //   } catch (err) {
  //     toast.error(err.message || "Could not verify the code.");
  //   } finally {
  //     setOtpLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setSubmitting(true));
    setError({ select: "", companyName: "", mobileNumber: "" });

    // Basic validations
    if (!additionalData.select) {
      setError((prev) => ({ ...prev, select: "Please select an option." }));
      dispatch(setSubmitting(false));
      return;
    }
    if (
      additionalData.select === "corporate" &&
      !additionalData.companyName?.trim()
    ) {
      setError((prev) => ({
        ...prev,
        companyName: "Company name is required for corporate selection.",
      }));
      dispatch(setSubmitting(false));
      return;
    }
    if (!additionalData.mobileNumber) {
      setError((prev) => ({
        ...prev,
        mobileNumber: "Mobile number is required.",
      }));
      dispatch(setSubmitting(false));
      return;
    }

    // Require verified phone (DISABLED)
    // if (!otpVerified) {
    //   toast.error("Please verify your phone number via OTP.");
    //   dispatch(setSubmitting(false));
    //   return;
    // }

    try {
      const parsedNumber = parsePhoneNumberFromString(
        additionalData.mobileNumber,
        additionalData.country || "AE"
      );
      if (!parsedNumber || !parsedNumber.isValid()) {
        setError((prev) => ({
          ...prev,
          mobileNumber: "Invalid mobile number for the selected country.",
        }));
        dispatch(setSubmitting(false));
        return;
      }

      // Check if this is a Google user completing their profile
      const pendingGoogleUser = localStorage.getItem("pendingGoogleUser");

      if (pendingGoogleUser) {
        console.log('completing Pending Google profile');
        // Complete Google user profile using the dedicated API function
        const { data: googleData, token } = JSON.parse(pendingGoogleUser);

        const updatedUserData = {
          ...googleData,
          ...additionalData,
          mobileNumber: parsedNumber.number, // E.164
          isVerified: false, // Changed from true since OTP is disabled
        };

        // Use the dedicated completeGoogleProfile function instead of direct axios call
        const response = await completeGoogleProfile(updatedUserData, token);

        // Set user in Redux and localStorage
        dispatch(setUser(response.user));
        localStorage.setItem("authToken", token);
        localStorage.setItem("authUser", JSON.stringify(response.user));
        localStorage.removeItem("pendingGoogleUser");

        dispatch(toggleCheckInbox());
        dispatch(resetFormData());

        toast.success("Profile completed successfully!");
      } else {
        // Regular signup flow
        const allData = {
          ...formData,
          ...additionalData,
          mobileNumber: parsedNumber.number, // E.164
          isVerified: false, // Changed from true since OTP is disabled
        };

        const response = await axios.post(
          `${base_URL}/api/auth/register`,
          allData
        );
        const { accessToken } = response.data;

        dispatch(toggleCheckInbox());
        dispatch(resetFormData());
        localStorage.setItem("authToken", accessToken);
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Something went wrong. Please try again."
      );
    } finally {
      dispatch(setSubmitting(false));
    }
  };

  return (
    <div>
      <p className="text-center">One last step before sending your enquiry</p>

      <div className="flex flex-col gap-4 mt-4">
        <div>
          <p className="text-dark font-semibold">I am...</p>
          <div className="relative cursor-pointer pr-1">
            <select
              value={additionalData.select || ""}
              onChange={handleSelectChange}
              className="w-full text-[#000000] py-2 pl-1 pr-4 cursor-pointer border outline-none border-bordered rounded-md "
            >
              <option value="">Select an option</option>
              <option value="individual">Individual</option>
              <option value="eventPlanner">Event Planner</option>
              <option value="corporate">Corporate</option>
            </select>
          </div>
          <span className="text-red-400 text-sm">{error.select}</span>
        </div>

        {additionalData.select === "corporate" && (
          <div className="flex flex-col gap-4">
            <CustomInput
              label={"Company Name"}
              type={"text"}
              error={error.companyName}
              placeholder={"Enter company name"}
              value={additionalData.companyName || ""}
              onChange={handleCompanyNameChange}
            />
          </div>
        )}

        <div className="flex flex-col gap-1">
          <div className="relative">
            <div className="absolute left-[60px] top-1/2 transform z-10 pointer-events-none">
              {countryCode}
            </div>
            <label htmlFor="" className="relative text-dark font-semibold font-outfit">
              Mobile Number
            </label>
            <PhoneInput
              id="mobile-input"
              placeholder="123 456 7890"
              value={additionalData.mobileNumber || ""}
              defaultCountry="AE"
              withCountryCallingCode
              autoComplete="on"
              onCountryChange={handleCountryChange}
              onChange={handleMobileNumberChange}
              style={{
                border: "1px solid #d1d5db",
                boxShadow: "none",
                borderRadius: "10px",
                outline: "none",
                width: "100%",
                padding: "0.5rem",
              }}
              className="no-focus-border"
            />
          </div>
          <span className="text-red-400 text-sm">{error.mobileNumber}</span>

          {/* OTP controls (DISABLED) */}
          {/* <div className="flex items-center gap-2 mt-2">
            <button
              type="button"
              className="px-3 py-1 border rounded-md"
              onClick={sendOtp}
              disabled={otpLoading || !additionalData.mobileNumber || resendIn > 0}
            >
              {resendIn > 0 ? `Resend in ${resendIn}s` : otpSent ? "Resend OTP" : "Send OTP"}
            </button>

            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              placeholder="Enter OTP"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
              className="border rounded px-3 py-1 w-28"
              disabled={!otpSent || otpVerified}
            />

            <button
              type="button"
              className="px-3 py-1 rounded-md text-white"
              style={{ background: otpVerified ? "#16a34a" : "#ef4444" }}
              onClick={verifyOtp}
              disabled={!otpSent || otpVerified || !otpCode || otpLoading}
            >
              {otpVerified ? "Verified" : "Verify"}
            </button>
          </div>
          {otpVerified && (
            <span className="text-green-600 text-sm">Phone verified</span>
          )} */}
        </div>

        <Button
          onClick={handleSubmit}
          label={isSubmitting ? "Submitting..." : "Submit"}
          disabled={isSubmitting}
        />
      </div>
    </div>
  );
};

export default AdditionalDetails;
